import { Page } from '@/core/architecture'

import { SettingsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * Settings Page
 * Implemented as a practical sample.
 */
export const Settings: Page = () => {
  const { state, actions } = useViewModel()

  return <SettingsTemplate state={state} onLogout={actions.onLogout} />
}
